import * as React from 'react';
function SvgCalendar(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentcolor"
      className="calendar_svg__fil-icon"
      {...props}
    >
      <rect width={22.5} height={19.5} x={0.752} y={3.75} rx={1.5} ry={1.5} />
      <path d="M.752 9.75h22.5M6.752 6V.75M17.252 6V.75" />
    </svg>
  );
}
export default SvgCalendar;
